export * from './getFileIcon'
